import { Component, OnInit, Injector } from '@angular/core';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-technical',
  templateUrl: './technical.component.html'
})

export class TechnicalComponent extends SeoAwareBaseComponent implements OnInit {
  public items: number[] = [
    5,
    2,
    5,
    4,
    3,
    3,
    4,
    4,
    6
  ]

  constructor(
    public injector: Injector
  ) {
    super(injector);
  }

  newArray(count: number): number[] {
    return Array.from(Array(count).keys());
  }

  ngOnInit(): void {
    this.setTitle('Detaliile tehnice ale proiectului Romanescu Park Residence');

    this.setMetaDescription(`
      Proiectul Romanescu Park Residence include: tructură de rezistență din cadre și planșee de
      beton armat, agent termic în sistem individual cu centrale termice de apartament, uși exterioare
      apartament metalice cu sisteme complexe de închidere și vizor, instalație de interfon și control
      acces etc.
    `);
  }
}



// WEBPACK FOOTER //
// ./src/app/downtown-life/technical.component.ts